// Example of SVG converted to js array, so it can be used with CIcon.
// the first argument is two last values of svg viewBox,
// the second argument is the SVG content stripped of SVG tags
export const managers = ['32 32', `
  <g>
    <circle stroke="var(--active-svg-stroke-color, #C2CFE0)" stroke-width="2" cx="16" cy="13" r="5"/>
    <path stroke="var(--active-svg-stroke-color, #C2CFE0)" stroke-width="2" d="M23,28A7,7,0,0,0,9,28Z"/>
    <path stroke="var(--active-svg-stroke-color, #C2CFE0)" stroke-width="2" d="M24,14a5,5,0,1,0-4-8"/>
    <path stroke="var(--active-svg-stroke-color, #C2CFE0)" stroke-width="2" d="M25,24h6a7,7,0,0,0-7-7"/>
    <path stroke="var(--active-svg-stroke-color, #C2CFE0)" stroke-width="2" d="M12,6a5,5,0,1,0-4,8"/>
    <path stroke="var(--active-svg-stroke-color, #C2CFE0)" stroke-width="2" d="M8,17a7,7,0,0,0-7,7H7"/>
  </g>
`]
